@if (isLoading$ | async) {
  <div class="soft-card">
    <div class="flex flex-row justify-center">
      <soft-loading-spinner></soft-loading-spinner>
    </div>
  </div>
} @else {
  @if (files$ | async; as files) {
    @if (showFilter) {
      <div class="w-full">
        <soft-input
          (input)="filter$.next(filterInput.value)"
          placeholder="{{ '#APPLICATION.ARCHIVE.FILTER' | translate }}"
          #filterInput
          >
        </soft-input>
      </div>
    }
    @if (files.length > 0) {
      @for (file of files; track file) {
        <div class="soft-card mt-3">
          <div class="flex flex-row justify-between flex-nowrap pt-2 pb-2 pl-1 pr-1 border-box">
            <div class="flex flex-col truncate">
              <span class="soft-title truncate mb-1">{{file.metaData.title ?? file.metaData.name}}</span>
              @if (file.metaData.summary) {
                <span class="xs color color-light">{{file.metaData.summary}}</span>
              }
              @if (file.metaData.title) {
                <span  class="xs color color-light">{{file.metaData.name}}</span>
              }
              <span class="xs color color-light"
                >{{ '#APPLICATION.ARCHIVE.FILESIZE' | translate }}
                {{ file.metaData.size | filesize }}</span
                >
                <span class="xs color color-light"
                  >{{ '#APPLICATION.ARCHIVE.LAST_MODIFIED' | translate }}
                  {{ file.metaData.lastModified | format: 'DATE.DEFAULT' }}</span
                  >
                </div>
                <div class="flex flex-nowrap">
                  @if ({file, files} | canPreview) {
                    <i
                      class="fa-regular fa-eye color-light mr-4 pointer"
                      (click)="preview({file, files})"
                    ></i>
                  }
                  @if (
                    !(file.fileKey | isArchiveDownloading | async)) {
                    <i
                      class="fa-regular fa-cloud-arrow-down custom-color pointer"
                      (click)="download(file)"
                    ></i>
                  } @else {
                    <i class="fa-regular fa-spinner fa-spin"></i>
                  }
                </div>
              </div>
            </div>
          }
        } @else {
          <div class="soft-card mt-3">
            <div class="flex flex-row justify-center">
              {{ '#APPLICATION.ARCHIVE.NO_FILES' | translate }}
            </div>
          </div>
        }
      }
    }


